// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"700206c8","277":"69fd2274","714":"9ebc4c26"}[chunkId] + ".chunk.js";
};